const DIGESTATE_JOBS = () => `/jobs/digestate`
const DIGESTATE_JOBS_BY_ID = (id: string) => `${DIGESTATE_JOBS()}/${id}`
export const DIGESTATE_JOB_EXPORT = () => `${DIGESTATE_JOBS()}/export`

export default {
  DIGESTATE_JOBS,
  DIGESTATE_JOBS_BY_ID,
  DIGESTATE_JOB_EXPORT
}
